import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.assign.js";
import _pt from "prop-types";
var _excluded = ["className", "defaultChecked", "id", "innerRef", "instructions", "labelA11y", "labelVisual", "required", "value"],
  _excluded2 = ["checked", "disabled", "name", "onChange", "highlightType", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import classNames from 'classnames';
import IconCheckmark from '@lmig/lmds-react-icons/dist/icons/Checkmark';
import IconEvoCheckmark from './EvoCheckmark';
import CheckboxGroupContext from './CheckboxGroupContext';
import "./checkbox.css";
export var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
    defaultChecked = _ref.defaultChecked,
    id = _ref.id,
    innerRef = _ref.innerRef,
    instructions = _ref.instructions,
    labelA11y = _ref.labelA11y,
    labelVisual = _ref.labelVisual,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var checked = otherProps.checked,
    disabled = otherProps.disabled,
    name = otherProps.name,
    onChange = otherProps.onChange,
    highlightType = otherProps.highlightType,
    children = otherProps.children,
    inputProps = _objectWithoutProperties(otherProps, _excluded2);
  var context = useContext(CheckboxGroupContext);
  var checkedFinal = typeof checked === 'undefined' && Array.isArray(context === null || context === void 0 ? void 0 : context.checked) ? context === null || context === void 0 ? void 0 : context.checked.includes(value) : checked;
  var disabledFinal = typeof disabled === 'undefined' ? context === null || context === void 0 ? void 0 : context.disabled : disabled;
  var nameFinal = typeof name === 'undefined' ? context === null || context === void 0 ? void 0 : context.name : name;
  var highlightTypeFinal = typeof highlightType === 'undefined' ? context === null || context === void 0 ? void 0 : context.highlightType : highlightType;
  var onChangeFinal = typeof onChange === 'undefined' ? context === null || context === void 0 ? void 0 : context.onChange : onChange;
  var idFinal = id || (name ? "".concat(name, "-").concat(value) : value);
  function getWrapperClassName() {
    return classNames('lm-FieldOption', 'lmig-Checkbox', className, {
      'is-error': highlightTypeFinal === 'error',
      'is-populated': value !== null && value !== undefined && value !== '',
      'is-disabled': disabled
    });
  }
  var classNameFieldOptionText = classNames('lm-FieldOption-text', {
    'lm-FieldOption-text--isBlank': !labelVisual
  });
  return /*#__PURE__*/React.createElement("label", {
    className: getWrapperClassName(),
    htmlFor: idFinal,
    key: idFinal
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    id: idFinal,
    name: nameFinal,
    value: value,
    className: "lm-FieldOption-input",
    required: required,
    disabled: disabledFinal,
    checked: checkedFinal,
    defaultChecked: defaultChecked,
    ref: innerRef,
    onChange: onChangeFinal
  }, inputProps)), /*#__PURE__*/React.createElement("div", {
    className: "lm-FieldOption-tick"
  }, /*#__PURE__*/React.createElement(IconEvoCheckmark, {
    size: "16",
    className: "lmig-Icon lmig-Icon-Checkmark lmig-Icon-evolution",
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(IconCheckmark, {
    size: "16",
    className: "lmig-Icon lmig-Icon-Checkmark lmig-Icon-classic"
  })), /*#__PURE__*/React.createElement("div", {
    className: classNameFieldOptionText
  }, labelVisual && labelA11y ? /*#__PURE__*/React.createElement("span", {
    "aria-hidden": !!labelA11y
  }, labelVisual) : labelVisual, labelA11y ? /*#__PURE__*/React.createElement("span", {
    className: "lm-a11yOnly"
  }, labelA11y) : null, instructions ? /*#__PURE__*/React.createElement("div", {
    className: "lm-FieldOption-instruct"
  }, instructions) : null));
};
Checkbox.propTypes = {
  /** Add an optional ID to this element: `<label class="lm-FieldOption lmig-Checkbox">`, if none is passed one will be generated for you. */id: _pt.string,
  /** Add custom classes to this element: `<label class="lm-FieldOption lmig-Checkbox">`. */className: _pt.string,
  /** Set an individual Checkbox name...consider setting this at the CheckboxGroup
     * level if you want grouped values in form submissions. */
  name: _pt.string,
  /** The value of this checkbox, passed on submit if the element is selected. */value: _pt.string,
  /** Selected state of this checkbox. */checked: _pt.bool,
  /** Set the default state of this checkbox if you are not using an onChange handler or the 'checked' prop,
     * i.e. the component is uncontrolled. See: https://reactjs.org/docs/uncontrolled-components.html */
  defaultChecked: _pt.bool,
  /** Disable this checkbox. */disabled: _pt.bool,
  /**
     * Require this checkbox be checked on native form submissions.
     * @default false
     */
  required: _pt.bool,
  /** Instructional text that appears below the checkbox label. */instructions: _pt.node,
  /** Apply situational colors and behaviors to this element. */highlightType: _pt.oneOf(['error']),
  /** This function is inherited from CheckboxGroup, but can be overriden at the individual checkbox level here. */onChange: _pt.func,
  /** A ref which will be attached to the `<input />` element to manage focus, values, etc. */innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object]),
  /** Only Checkbox components should be passed as children. */children: _pt.node
};